<div class="animated-box" [@slideInTop]="state" [@slideOutTop]="state" *ngFor="let alert of alerts">
    <!-- Container externo com fundo colorido -->
    <div id="toast" class="animated-box-content mt-2 m-auto max-w-[500px] mb-4 rounded-lg shadow-lg pl-[6px]"
         [ngClass]="{
            'bg-red-600': this.alert.alertType === 'error',
            'bg-blue-600': this.alert.alertType === 'info',
            'bg-green-600': this.alert.alertType === 'success',
            'bg-yellow-500': this.alert.alertType === 'warn'
         }" role="alert">

        <!-- Container interno com gradiente cinza -->
        <div class="flex items-start p-4 pl-4 w-full bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg">
            <!-- Ícone em quadrado arredondado com shadow -->
            <div *ngIf="this.alert.alertType === 'error'" class="flex-shrink-0 w-10 h-10 rounded-lg bg-red-600 flex items-center justify-center mr-4 shadow-md">
                <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z"/>
                </svg>
            </div>
            <div *ngIf="this.alert.alertType === 'info'" class="flex-shrink-0 w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center mr-4 shadow-md">
                <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z"/>
                </svg>
            </div>
            <div *ngIf="this.alert.alertType === 'success'" class="flex-shrink-0 w-10 h-10 rounded-lg bg-green-600 flex items-center justify-center ml-2 mr-4 shadow-md">
                <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
            </div>
            <div *ngIf="this.alert.alertType === 'warn'" class="flex-shrink-0 w-10 h-10 rounded-lg bg-yellow-500 flex items-center justify-center mr-4 shadow-md">
                <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z"/>
                </svg>
            </div>

            <!-- Conteúdo do alerta -->
            <div class="flex-1">
                <div class="font-inter font-[500] text-[16px] text-gray-800">{{ this.alert.title || this.getDefaultTitle(this.alert.alertType) }}</div>
                <div class="font-inter font-[400] text-[14px] text-gray-700 mt-1">{{ this.alert.message }}</div>
            </div>
        </div>
    </div>
</div>

